export enum RouteName {
  List = 'manage-merchant-configuration-list',
}
